/**
 * Lightweight CSS-only tooltip. Wrap any element to show a styled bubble on
 * hover with zero delay (vs the ~700ms native ``title`` attribute delay).
 *
 * Position defaults to ``top`` (above the trigger). Works on disabled
 * buttons because hover is on the wrapper span, not the disabled child.
 */
import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  /** Position relative to the trigger. */
  position?: 'top' | 'bottom';
}

const Tooltip: React.FC<TooltipProps> = ({ text, children, position = 'top' }) => {
  const posClasses =
    position === 'top' ? 'bottom-full mb-1.5' : 'top-full mt-1.5';
  return (
    <span className="relative inline-block group">
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute left-1/2 -translate-x-1/2 ${posClasses} px-2 py-1 bg-slate-800 text-white text-xs font-medium rounded shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-100 z-50`}
      >
        {text}
      </span>
    </span>
  );
};

export default Tooltip;
